import { IAttendance, IPlayer } from "@grassrootly/api/entities";
import { UpdateAttendancePayload } from "@grassrootly/api/gateways";
import server from "@grassrootly/api/providers/supabase-provider/Server";
import withErrorCheck from "../CheckError";

export const UpdateAttendance = async ({ id, playerId, attending }: UpdateAttendancePayload): Promise<IAttendance> => {
  const data = withErrorCheck(
    await server.from("GameAttendances").select("*").eq("game_id", id).eq("player_id", playerId)
  );
  let attendance = data?.length ? data[0] : null;
  if (!attendance) {
    return withErrorCheck(
      await server
        .from("GameAttendances")
        .insert({
          player_id: playerId,
          game_id: id,
          attended: attending,
        })
        .select()
    )[0];
  }
  return withErrorCheck(
    await server
      .from("GameAttendances")
      .update({ ...attendance, attended: attending })
      .eq("id", attendance.id)
      .select()
  )[0];
};
